import { render, staticRenderFns } from "./WorkFloNextActionIndicator.vue?vue&type=template&id=a64fc522&scoped=true&"
import script from "./WorkFloNextActionIndicator.vue?vue&type=script&lang=js&"
export * from "./WorkFloNextActionIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64fc522",
  null
  
)

export default component.exports